import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AutoLoginClient } from 'app/auth/auto-login.client';
import { BzgModalService, BzgToastService } from 'bz-genome-angular';
import { EmailSentDialogComponent } from './email-sent-dialog/email-sent-dialog.component';

@Component({
    selector: 'account-information',
    templateUrl: 'account-information.component.html',
    styleUrls: ['account-information.component.scss']
})
export class AccountInformationComponent {
    public userName = '';
    public errorSendingEmail = false;

    constructor(private _translateService: TranslateService,
        private _toastService: BzgToastService,
        private _autoLoginClient: AutoLoginClient,
        private _modalService: BzgModalService) { }

    ngOnInit() {
        this._autoLoginClient.getProfile()
            .subscribe((response) => {
                this.userName = response && response.username ? response.username : '';
            });
    }

    public changePassword() {
        this._autoLoginClient.sendVerificationCode(this.userName).subscribe((response) => {
            switch (response) {
                case 'SendVerificationCodeSuccessful':
                    this.errorSendingEmail = false;
                    this._modalService.open(EmailSentDialogComponent, {closeOnBackdropClick: false, closeOnRouterNavigation: true});
                    break;
                    case 'SendVerificationCodeSMTPWrongConfiguration':
                        this._translateService.get('AUTOADMIN.SEND_EMAIL_WRONG_CONFIGURATION').subscribe((message: string) => {
                            this._toastService.open(
                                message,
                                {
                                    type: 'error',
                                    duration: 0,
                                    verticalPosition: 'bottom',
                                    horizontalPosition: 'right'
                                });
                        });
                        break;
                    case 'SendVerificationCodeMissingSMTPConfiguration':
                        this._translateService.get('AUTOADMIN.MISSING_SMTP_CONFIGURATION').subscribe((message: string) => {
                            this._toastService.open(
                                message,
                                {
                                    type: 'error',
                                    duration: 0,
                                    verticalPosition: 'bottom',
                                    horizontalPosition: 'right'
                                });
                        });
                        break;
                    case 'SendVerificationCodeUserNotFound':
                    case 'SendVerificationCodeUnexpectedError':
                        this._translateService.get('AUTOADMIN.SEND_EMAIL_UNEXPECTED_ERROR').subscribe((message: string) => {
                            this._toastService.open(
                                message,
                                {
                                    type: 'error',
                                    duration: 0,
                                    verticalPosition: 'bottom',
                                    horizontalPosition: 'right'
                                });
                        });
                        break;
                    default:
                        this._translateService.get('GLOBAL.GENERIC_ERROR_MSG').subscribe((message: string) => {
                            this._toastService.open(
                                message,
                                {
                                    type: 'error',
                                    duration: 0,
                                    verticalPosition: 'bottom',
                                    horizontalPosition: 'right'
                                });
                        });
                        break;
            }
        });
    }
}
